import { render, staticRenderFns } from "./checkout_prices_purchases.vue?vue&type=template&id=96e271e2&scoped=true"
import script from "./checkout_prices_purchases.vue?vue&type=script&lang=js"
export * from "./checkout_prices_purchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e271e2",
  null
  
)

export default component.exports